import Breadcrumb from "../components/Breadcrumb";

const AboutPage = () => {
  return (
    <>
      <div className="md:mx-20 mx-auto px-4 mt-8">
        <Breadcrumb category="about" />
        <h1 className="text-3xl font-bold text-gray-800">About Page</h1>
        <p className="mt-4 text-gray-600">This is the about page.</p>
      </div>
    </>
  );
};

export default AboutPage;
